// extracted by mini-css-extract-plugin
export var subtitle = "Subtitle-module--subtitle--8a569";
export var sm = "Subtitle-module--sm--b1a10";
export var md = "Subtitle-module--md--eb539";
export var lg = "Subtitle-module--lg--e7015";
export var black = "Subtitle-module--black--86835";
export var white = "Subtitle-module--white--50a3e";